import type {CohortUserADto} from '@cohort/admin-schemas/cohort';
import Table from '@cohort/merchants/components/Table';
import {getUserRoute} from '@cohort/merchants/lib/Pages';
import MembersTableDropdown from '@cohort/merchants/pages/users/cohort/members/MembersTableDropdown';
import type {PaginationDto} from '@cohort/shared/schema/common/pagination';
import {formatDate} from '@cohort/shared/utils/format';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

interface MembersTableProps {
  users: CohortUserADto[];
  isLoading: boolean;
  pagination?: PaginationDto & {onPageChange?: (page: number) => void};
}

const MembersTable: React.FC<MembersTableProps> = ({users, isLoading, pagination}) => {
  const navigate = useNavigate();

  const {t} = useTranslation('pages', {
    keyPrefix: 'users.cohort.members.membersTable',
  });

  const headers = [
    {label: t('tableHeaderEmail')},
    {label: t('tableHeaderMemberHandle')},
    {label: t('tableHeaderMemberSince')},
    {label: t('tableHeaderLastActiveAt')},
    {label: ''},
  ];

  const tdClassName = 'py-3 pr-1 text-slate-500';

  return (
    <Table
      headers={headers}
      isLoading={isLoading}
      emptyState={{
        isEmpty: users.length === 0,
        title: t('titleEmpty'),
        description: t('descriptionEmpty'),
      }}
      pagination={pagination}
    >
      {users.map(user => (
        <tr
          key={user.id}
          className="cursor-pointer py-4 text-sm hover:bg-slate-50"
          onClick={() => navigate(getUserRoute(user.id).path)}
        >
          <td className="pr-1 font-semibold">{user.email}</td>
          <td className={tdClassName}>{user.membershipPassHandle}</td>
          <td className={tdClassName}>{formatDate(user.memberSince)}</td>
          <td className={tdClassName}>{formatDate(user.lastActiveAt)}</td>
          <td className={tdClassName}>
            <MembersTableDropdown user={user} />
          </td>
        </tr>
      ))}
    </Table>
  );
};

export default MembersTable;
